import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
// Modules
import userData from './modules/User'
import dashboard from './modules/Dashboard'
import challenge from './modules/Challenge'
import bookReading from './modules/BookReading'
import bookCatalog from './modules/BookCatalog'
import common from './modules/Common'
import snackbar from './modules/Snackbar'

import ICommit from '@/store/contracts/commit'
// TODO

import getters from './getters'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
    // Al cambiar esta llave debe cambiarse también en "@/utils/request" para poder obtener el token
    key: 'student-beereaders-app',
    storage: window.localStorage,
    reducer: (state: any) => ({
        token: state.token,
        categories: state.categories,
        userData: state.userData,
        dashboard: state.dashboard,
        common: state.common,
    }),
})

const defaultState: {
    categories: Array<any>
    loading: boolean
    token: string
    isValid: boolean
    rankingMode: string
} = {
    categories: [],
    loading: false,
    token: '',
    isValid: false,
    rankingMode: '',
}

const store = new Vuex.Store({
    state: defaultState,
    mutations: {
        categories: (state, value) => {
            state.categories = value
        },
        clearSession(state) {
            Object.assign(state, defaultState)
            setTimeout(() => {
                vuexPersist.storage?.clear()
            }, 10)
        },
        loading: (state, value) => {
            state.loading = value
        },
        setToken: (state, value) => {
            state.token = value
        },
        rankingMode: (state: any, value: any) => {
            state.rankingMode = value
        },
    },
    actions: {
        changeCategories({ commit }, categories) {
            commit('categories', categories)
        },
        clearSession({ commit }) {
            commit('clearSession')
        },
        setLoadingState({ commit }, value) {
            commit('loading', value)
        },
        setToken({ commit }, value) {
            commit('setToken', value)
        },
        isValidToken({ state }, value) {
            state.isValid = value
        },
        resetState({ state }) {
            Object.assign(state, defaultState)
        },
        setRankingMode({ commit }: ICommit, value: any) {
            commit('rankingMode', value)
        },
    },
    modules: {
        userData,
        dashboard,
        bookReading,
        challenge,
        bookCatalog,
        common,
        snackbar
    },
    getters,
    plugins: [vuexPersist.plugin],
})

export default store
